.button {
  margin: 0;
  border: 0;
  min-height: 24px;
}

.addButton {
  margin-top: 0.5rem;
}

.notFound {
  color: var(--red);
}

.item > td {
  word-break: break-word;
  padding-left: 1.5em;
}

.item:nth-child(odd) {
  background: var(--silver);
}

.listEntries {
  padding: 1em;
  border: 1px solid var(--black);
}

.nameColumn {
  padding: 0.5em;
}

.idColumn {
  min-width: 6em;
}

.actionsColumn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.5em;
}

.description {
  margin-top: 0.5em;
  display: flex;
  flex-direction: row;
}

.description button {
  height: 3em;
  white-space: pre;
}

.description p,
.description div {
  flex-grow: 1;
}

.tight {
  margin: 0;
}

.formItem {
  margin: 2em 0;
}

.existingParticipants {
  margin-bottom: 0;
}

.courseTitleWrapper {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
}

.courseTitle {
  display: inline-flex;
}

.courseAccordionItem {
  padding: 1rem;
  border: 1px solid var(--darkSilver);
  border-top: none;
}

.courseAccordionWrapper {
  margin-bottom: 2rem;
}

.addButtonContainerDescription {
  display: flex;
  justify-content: space-between;
}

.addButtonContainer {
  display: flex;
  justify-content: flex-end;
}

.addParticipantsDescription {
  margin: 0;
  padding-top: 1rem;
  font-size: 0.875rem;
  color: #555;
  font-weight: 300;
}
